module.exports = __webpack_public_path__ + "static/icon-a41a0be9346407e058e65f9c72253cb2.png";